import { css } from "emotion";
import { max, min } from "../../../../utils/CssUtils";

const FlexRow = ({
  children,
  className = css({}),
  spacing = 0,
  mobileSpacing = spacing,
  mobileStyles = {},
  style = {},
  passChildProps = {}
}) => {
  const HCenteringWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    "&>div": {
      // spacing AKA margins for each element
      [min(601)]: {
        marginRight: spacing,
        "&:last-child": {
          marginRight: "0"
        }
      },
      [max(600)]: {
        marginBottom: mobileSpacing,
        "&:last-child": {
          marginBottom: "0"
        }
      }
    },
    [max(600)]: {
      flexDirection: "column",
      ...mobileStyles
    },
    ...style
  });

  return (
    <div className={css([HCenteringWrapper, className])}>
      {children.map(child => {
        Object.keys(passChildProps).forEach(key => {
          child.props[key] = passChildProps[key];
        });

        return child;
      })}
    </div>
  );
};

export default FlexRow;
